// Net area of the floor: the Flood polygons' area minus their holes.
import { _polylineArea } from './utils.js'

// ── Net area (outer area minus hole areas) ─────────────────────────────
export function computeNetArea(manifest) {
  if (!manifest?.length) return 0
  let total = 0
  for (const e of manifest) {
    if (e.layer === 'Flood' && e.type === 'LWPOLYLINE' && e.closed && e.points?.length >= 3) {
      let area = _polylineArea(e.points)
      for (const hole of (e.holes ?? [])) area -= _polylineArea(hole)
      total += Math.max(0, area)
    }
  }
  return total
}
